module.exports = {
    abrir: 'Abrir',
    abrirNovaAba: 'Abrir anexo em nova aba',
    achados: 'Achados',
    agendado: 'Agendado',
    agendados: 'Agendados',
    alteracoesRetinaNervoOptico: 'Alterações na retina ou nervo óptico',
    anexarArquivo: 'Anexar arquivos',
    anexoEnvioImagens: 'Anexo (.jpg, .jpeg, .png, .bmp, .pdf)',
    anexoPrincipal: 'Anexo principal',
    anexos: 'Anexos',
    anexosInseridosSucesso: 'Anexos inseridos com sucesso.',
    assinado: 'Assinado',
    assinando: 'Aguarde - assinando digitalmente o laudo...',
    ausente: 'Ausente',
    avaliar: 'Avaliar',
    BuscaFuncionario: {},
    calibreArteriolar: 'Calibre Arteriolar',
    carregandoExame: 'Carregando exame',
    categoria: 'Categoria',
    centralizadaMacula: 'Centralizada na mácula.',
    centralizadaNervoOptico: 'Centralizada no nervo óptico.',
    cidadeProcedencia: 'Município de procedência',
    cirurgiasOculares: 'Cirurgias oculares',
    coliriosAntiglaucomatosos: 'Colírios antiglaucomatosos',
    coloracao: 'Coloração',
    comImagem: 'Com imagem',
    comorbidadesFatoresRisco: "Comorbidades e Fatores de Risco",
    conclusao: 'Conclusão',
    confirmando: 'Confirmando laudo',
    contornos: 'Contornos',
    corColoracao: 'Cor/Coloração',
    cruzamentosArteriovenosos: 'Cruzamentos Arteriovenosos',
    dadosInvalidos: 'Dados inválidos. Verifique os dados informados e tente novamente.',
    dataHoraAtendimento: 'Data/hora do atendimento',
    degeneracoesMaculares: 'Degenerações maculares / degeneração macular relacionada à idade (DMRI)',
    degeneracoesRetinianas: 'Degenerações retinianas',
    descolamentosRasgos: 'Descolamentos/Rasgos',
    descricaoEstudo: 'Descrição do estudo',
    descricaoExame: 'Descrição do exame',
    descritores: 'Descritores',
    direcionados: 'Direcionado ao meu usuário',
    direcionadosAMim: 'Direcionados a mim',
    discordoP: 'Discordo parcialmente',
    discordoT: 'Discordo totalmente',
    distrofiasRetinianas: 'Distrofias retinianas',
    doencas: "Doenças",
    doencasCoriorretinianas: 'Doenças coriorretinianas',
    doencasCoriorretinianas: 'Doenças coriorretinianas',
    doencasMacula: "Doenças da Mácula",
    doencasNervoOptico: "Doenças do Nervo Óptico",
    doencasVasculares: "Doenças Vasculares",
    emailInvalido: 'Email inválido',
    erroAssinatura: 'Erro ao assinar digitalmente o laudo',
    erroGerarTermo: 'Não foi possível gerar o termo de autorização. Tente imprimir o termo através da tela de exames.',
    erroSortearExame: 'Não foi possível sortear o próximo exame para laudo. Tente novamente e se o problema persistir, entre em contato com os administradores.',
    escavacaoPapilar: 'Escavação Papilar',
    especificacao: "Especificação",
    especificacaoTempoObrigatoria: "Especificação do tempo é obrigatória",
    especificar: "Especificar",
    especificarMedicamento: "Especifique o medicamento",
    estrutura: 'Estrutura',
    exameMaisAntigoSemLaudo: 'Data do exame mais antigo sem laudo',
    examesAgendados: 'Agendados',
    examesComImagens: 'Com imagens',
    exameSelecionado: 'Exame selecionado',
    exameSemImagens: 'Este exame não possui imagens anexadas até o momento',
    examesInvalidos: 'Inválidos',
    examesPacs: 'PACS',
    examesSelecionados: 'Exames selecionados',
    examesValidos: 'Válidos',
    exameValidado: 'Exame validado',
    exsudatos: 'Exsudatos em periferia',
    finalidade: 'Finalidade',
    fotosAdicionais: 'Fotos adicionais',
    gerandoResumo: 'Gerando resumo do laudo',
    glaucoma: 'Glaucoma',
    hbA1c: 'HbA1c',
    hipoglicemiantesOrais: 'Hipoglicemiantes orais',
    hipoteseDiagnostica: 'Hipótese diagnóstica',
    hipoteses: 'Hipóteses',
    historiaClinica: 'História clínica',
    historiaMorbidaPregressa: 'História mórbida pregressa',
    historicoCirurgiaOcular: 'Histórico de cirurgia ocular',
    ignorandoExame: 'Ignorando exame',
    imagemInvalida: 'O campo deve conter uma imagem do tipo JPG',
    imagensOlhoDireito: 'Imagens do olho direito',
    imagensOlhoEsquerdo: 'Imagens do olho esquerdo',
    imformacoesCompl: 'Informações complementares',
    impressaoDiagnosticaConclusao: 'Impressão Diagnóstica (Conclusão)',
    impressoesDiagnosticas: 'Impressões Diagnósticas',
    indicacaoExame: 'Indicacao do exame',
    infeccoesTumores: 'Infecções e Tumores',
    infoClinicas: 'Informações clínicas',
    // Labels do formulário de laudo
    informacoesTecnicasQualidade: 'Informações Técnicas e Qualidade',
    instituicaoSolicitante: 'Instituição solicitante',
    invalido: 'Inválido',
    laudadoPorMim: 'Laudados por mim',
    laudoAssinado: 'Laudo assinado digitalmente com sucesso',
    laudoEmEmissao: 'Devido à demora na emissão do laudo, este exame foi acessado por outro profissional. O próximo exame será carregado.',
    laudosEmitidos: 'Laudos emitidos',
    laudoTextual: 'Laudo textual',
    lesoesVasculares: 'Lesões Vasculares',
    local: 'Local',
    maculaFovea: 'Mácula e Fóvea',
    medicamentosEmUso: "Medicamentos em uso",
    medicamentosHipertensao: 'Medicamentos para hipertensão',
    medicoExecutor: 'Médico executor',
    mensagemAlertaCancelamento: 'Você confirma o cancelamento do envio de imagens?',
    mensagemConfirmarEnvioExame: 'Deseja enviar as imagens do exame agora?',
    mensagemConfirmarTermo: 'Deseja imprimir o TCLE?',
    minimoUmaCirurgiaOcular: 'Selecione pelo menos uma cirurgia ocular',
    minimoUmColirio: 'Selecione pelo menos um colírio',
    minimoUmMedicamento: 'Selecione pelo menos um medicamento',
    modulo: 'Retinografia',
    motivo: 'Motivo',
    motivoExame: 'Motivo do exame',
    naoFoiPosisvelCarregarExamesInvalidos: 'Não foi possível carregar os dados de exames inválidos',
    naoFoiPossivelCarregarExamesComLaudo: 'Não foi possível carregar os dados de exames laudados',
    naoFoiPossivelCarregarLaudosEmitidos: 'Não foi possível carregar os dados de laudos emitidos',
    naoFoiPossivelCarregarSemLaudo: 'Não foi possível carregar os dados de exames sem laudo',
    naoFoiPossivelCarregarSemLaudo72h: 'Não foi possível carregar os dados de exames com laudo atrasado',
    naoFoiPossivelCarregarTotais: 'Não foi possível carregar os dados de produtividade',
    nenhumAnexo: 'Nenhum anexo encontrado',
    nenhummExameParaLaudo: 'Nenhum exame disponível para laudo',
    nervoOpticoDiscoOptico: 'Nervo Óptico (Disco Óptico)',
    noaExisteEquipamento: 'A instituição do exame não possui nenhum ponto cadastrado. Entre em contato com os administradores.',
    novaRede: 'Nova rede',
    numeroExame: 'Número do exame',
    ocupacional: 'Ocupacional',
    olhoAnalisado: 'Olho Analisado',
    olhoExaminado: 'Lateralidade ou Olho examinado',
    origem: 'Origem',
    outrasCondicoesRetinianas: 'Outras condições retinianas',
    outrasCondicoesRetinianas: 'Outras condições retinianas',
    outrasDoencas: "Outras doenças",
    outrasInformacoes: 'Outras informações',
    outrasInfosPert: 'Outras informações pertinentes',
    outroAnexo: 'Outro anexo',
    outroAnexoExame: 'Outro anexo (.zip, .rar)',
    outrosColiriosAntiglaucomatosos: 'Outros colírios antiglaucomatosos',
    outrosMedicamentosUso: "Outros medicamentos em uso",
    pacs: 'PACS',
    patologiasVascularesRetina: 'Patologias vasculares da retina',
    pesquisar: 'Pesquisar',
    pigmentacao: 'Pigmentação',
    previewImagem: 'Visualização da imagem',
    problemasEstruturaisRetinianos: 'Problemas Estruturais/Retinianos',
    processosInflamatorios: 'Processos inflamatórios',
    proximoExame: 'Próximo exame',
    publicar: 'Publicar',
    qualidadeImagem: 'Qualidade da Imagem',
    redeAlterada: 'Rede alterada',
    reflexoDeLuz: 'Reflexo de Luz',
    reflexoFoveal: 'Reflexo Foveal',
    relacaoEscavacaoDiscoEstimada: 'Relação Escavação',
    remover: 'Remover',
    responsavelEnvio: 'Responsável pelo envio',
    resultadoExames: 'Resultado de exames anteriores',
    resultadosExamesAnteriores: 'Resultado de exames anteriores',
    resumoLaudo: 'Resumo do laudo',
    retinaPerifericaFundo: 'Retina Periférica e Fundo (Polo Posterior e Periferia)',
    retinopatiaHipertensaoArterial: 'Retinopatia por hipertensão arterial',
    retinopatiaPrematura: 'Retinopatia da prematuridade',
    retinopatriaDiabetica: 'Retinopatia diabética',
    retinosePigmentar: 'Retinose pigmentar',
    salvandoAntecedente: 'Salvando antecedente',
    sinaisRetinopatiaDisbetica: 'Sinais de Retinopatia Diabética',
    sinaisRetinopatiaHipertensiva: 'Sinais de Retinopatia Hipertensiva',
    solicitacaoRegistrada: 'Solicitação registrada',
    subcategoria: 'Subcategoria',
    tamanhoMaximo: "Tamanho máximo: 255 caracteres",
    telediagnostico: 'Telediagnostico',
    tempoDiagnostico: 'Tempo de diagnóstico (em anos)',
    tempoUso: "Tempo de uso",
    tempoUsoMinimo: "Tempo de uso deve ser maior que 0",
    tempoUsoObrigatorio: "Tempo de uso é obrigatório",
    termosDescricao: 'Termos da descrição do exame',
    teste: 'Teste',
    tipo: 'Tipo',
    tipoContato: 'Tipo de contato',
    tipoExame: 'Tipo de exame',
    tipoRetinopatiaDiabetica: 'Tipo de retinopatia diabética',
    titulo: 'Envio de imagens',
    tituloConfirmarEnvioExame: 'Deseja enviar as imagens?',
    tituloModalCancelamento: 'Confirmação de cancelamento',
    todasImagens: 'Todas as imagens',
    todosTermos: 'Todos os termos',
    tortuosidade: 'Tortuosidade',
    trocarRede: 'Trocar rede',
    tumores: 'Tumores',
    ultimaGlicemia: 'Última glicemia',
    ultrapassouTempoPrevisto: 'Ultrapassou o tempo previsto para laudo',
    usoColirioAntiglaucomatoso: 'Faz uso de colírio antiglaucomatoso?',
    usoHipoglicemiantesOrais: 'Faz uso de hipoglicemiantes orais?',
    usoInsulina: 'Faz uso de insulina?',
    usoMedicamentoHipertensao: 'Faz uso de medicação para hipertensão?',
    valido: 'Válido',
    vasos: 'Vasos',
    vasosSanguineosArteriolasVenulas: 'Vasos Sanguíneos (Arteríolas e Vênulas)',
    vitreo: 'Vítreo'
};
